<template>
	<div class="line">
		<slot />
	</div>
</template>

<style scoped>
.line {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	text-align: justify;

	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 120%;

	color: rgba(255, 255, 255, 0.7);
}
</style>
